import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SystemService } from 'app/Services/system.service';
import { LoginService } from 'app/Services/login.service';

@Component({
    selector: 'np-prepare-combine-catalog',
    templateUrl: './prepare-combine-catalog.component.html',
    standalone: false,
    styleUrls: ['./prepare-combine-catalog.component.css']
})
export class PrepareCombineCatalogComponent implements OnInit {

    public constructor(
        private activatedRoute: ActivatedRoute,
        public systemService: SystemService,
        public translate: TranslateService,
        private router: Router,
        private loginService: LoginService
    ) {
    }

    public ngOnInit(): void {
        this.systemService.currentNavigationTitle = this.translate.instant('Katalog vorbereiten');
    }

    public goBack(): void {
        const customerId = this.loginService.currentUser.customerId;
        const catalogId = this.activatedRoute.snapshot.paramMap.get('sourceCatalogId');
        this.router.navigate(['/dataprocess/preparation/catalog', customerId, catalogId, 'infos']);
    }
}
